import { useState } from 'react';
import * as S from './styles';
//components
import Calendar from '../../../components/Filter/Calendar';
//icons
import { Export } from '@phosphor-icons/react';
interface ITitle {
    setDateTitlle: (data: Date) => void;  
    startingYear: number;
}
export default function TitleDash({ setDateTitlle, startingYear }: ITitle) {
    const [dateFilter, setDateFilter] = useState(new Date());
    return (
        <S.Container>
            <S.Title>
                <S.H4>Dashboard</S.H4>
                <S.H6>Gerencie os dados do sistema</S.H6>
            </S.Title>

            <S.ContentFilter>
                <Calendar setDate={setDateTitlle} oldestYear={startingYear}/>

                <S.Button>
                    <Export size={24} />
                    <S.H6>Exportar</S.H6>
                </S.Button>
            </S.ContentFilter>
        </S.Container>
    )
}